export default __webpack_public_path__ + "static/media/GuessJobs2_01.04653799.png";